import { mapActions, mapGetters } from "vuex";
import ContactsForm from "@/modules/pages/components/contacts-form/index.vue";
import dynamicsHead from "@/mixins/dynamics-head";

export default {
  name: "contact-page",
  mixins: [dynamicsHead],
  watch: {
    async $route() {
      await this.fetchPage("contact-page");
      this.setPageMetaInfo(this.page)
    },
  },
  async created() {
    await this.fetchPage("contact-page");
    this.setPageMetaInfo(this.page)
  },
  components: {
    ContactsForm
  },
  computed: {
    ...mapGetters({
      contacts: "setting/variables",
      page: "pages/page",
    }),

    getContactsWithMap() {
      return this.contacts?.contactInfo.filter(info => !!info.map);
    },

    getContactsWithoutMap() {
      return this.contacts?.contactInfo.filter(info => !info.map);
    },
  },
  methods: {
    ...mapActions({
      fetchPage: "pages/GET_PAGE",
    }),
    parsePhones(phoneString) {
      return phoneString.split('<br />\r\n')
    },
    /**
     * @param {keyof ContactPage|string} field
     * @return {string}
     */
    getContact(field) {
      return this.contacts?.contactPage[field] || "";
    },
  },
};
